import { useTranslation } from '@shared/localization';
import { JSX } from 'react';

import { PayButton } from '@/components/pages/stored-instruments/utils/PayButton';
import DenizBankService from '@/services/denizbank/DenizBankService';

interface IPayWithDenizBankBtnProps {
  navigation?: JSX.Element | null;
}

export function PayWithDenizBankBtn({ navigation }: IPayWithDenizBankBtnProps) {
  const { t } = useTranslation();

  return (
    <div className="flex space-x-2">
      {navigation}
      <PayButton
        onClick={DenizBankService.trigerRedirectToDenizBank}
        title={t('Proceed to pay')}
      />
    </div>
  );
}
